import { z } from "zod";
import { LinkItemSchema } from "../LinkItem";
import { RichTextSchema } from "../RichText";
export const BladeHeaderSchema = z.object({
    supertitle: z.string().optional(),
    title: z.string().optional(),
    subtitle: z.string().optional(),
    description: RichTextSchema.optional(),
    links: z.array(LinkItemSchema).optional(),
});
//# sourceMappingURL=index.js.map